import { Box } from '@/components/ui/box';
import { RadioGroup } from '@/components/ui/radio';
import { VStack } from '@/components/ui/vstack';
import { HStack } from '@/components/ui/hstack';
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalFrame from '../../components/basic/ModalFrame';
import RadioButton from '../../components/basic/RadioButton';
import BasicElement from '../../components/basic/BasicElement';
import SearchListElement from '../../components/workflow/SearchListElement';
import ImageSynced from '../../components/media/ImageSynced';
import avatar1 from '../../assets/images/avatar_mit_background.png';
import xmp0_task from '../../assets/images/samples/laundry/task_laundry.jpeg';
import xmp1_task from '../../assets/images/samples/bruschetta/task_bruschetta.jpeg';
import { changeSettings } from '../../stores/mainSlice';

export default function ModalListFormat({ showModal, setShowModal }) {
    const dispatch = useDispatch();

    const [view, setView] = useState(useSelector((state) => state.settings.rasterView || false) ? '0' : '1');

    const selectView = (newView) => {
        setView(newView);
    };

    const onClose = (isOk) => {
        setShowModal(false);
        if (isOk) {
            dispatch(changeSettings({ settings: { rasterView: view == '0' } }));
        }
    };

    return (
        <ModalFrame title="appSettings.listFormat" text="modalFormat.text" showModal={showModal} onClose={onClose}>
            <RadioGroup
                value={view}
                name="RadioGroup"
                accessibilityLabel={i18n.t('modalFormat.text')}
                onChange={(nextView) => {
                    setView(nextView);
                }}
                className="mr-4 w-[100%]">
                <RadioButton onPress={selectView} text="modalFormat.raster" variant="outline" value="0" />
                <RadioButton onPress={selectView} text="modalFormat.list" variant="outline" value="1" />
            </RadioGroup>
            {view == '0' ? (
                <HStack space="md" className="mt-2 justify-between">
                    <SearchListElement task={{ title: i18n.t('appSettings.task0'), media: [xmp0_task], steps: [0, 0, 0, 0, 0, 0, 0, 0] }} />
                    <SearchListElement task={{ title: i18n.t('appSettings.task1'), media: [xmp1_task], steps: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }} />
                </HStack>
            ) : (
                <VStack>
                    <BasicElement media={xmp0_task} prefix="" title={i18n.t('appSettings.task0')} text={i18n.t('showWorkflowScreen.numberOfSteps', { steps: 8 })} disabled={false} mark1={false}>
                        <Box className="border-primary-900 border rounded-full self-end p-0.5">
                            <ImageSynced key={avatar1} uri={avatar1} isAvatar={true} />
                        </Box>
                    </BasicElement>
                    <BasicElement media={xmp1_task} prefix="" title={i18n.t('appSettings.task1')} text={i18n.t('showWorkflowScreen.numberOfSteps', { steps: 15 })} disabled={false} mark1={false}>
                        <Box className="border-primary-900 border rounded-full self-end p-0.5">
                            <ImageSynced key={avatar1} uri={avatar1} isAvatar={true} />
                        </Box>
                    </BasicElement>
                </VStack>
            )}
        </ModalFrame>
    );
}
